// extracted by mini-css-extract-plugin
export default {"root":"Modal_root__oCTTm","content":"Modal_content__SB+Tx"};